import { Component, OnInit, OnDestroy, AfterViewInit, HostListener } from '@angular/core';
import { PageType, BetOutcomeOddDifference } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { IBetTypeSelection } from 'src/app/models/betType/betTypeSelection.interface';
import { Subscription } from 'rxjs';
import { EventsService } from 'src/app/services/events.service';
import { SportsService } from 'src/app/services/sports.service';
import { TicketService } from 'src/app/services/ticket.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { IBet } from 'src/app/models/bet/bet';

import { IEventLiveResultInfo } from 'src/app/models/event/eventLiveResultInfo.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { blinkBorderAnimation } from 'src/app/animations/blink';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { IEventsAndSelectionsMobileLive } from 'src/app/models/event/eventsAndSelectionsMobileLive.interface';
import { CacheService } from 'src/app/services/cache.service';
import { IBetsAndOutcomesForBetTypeGroup } from 'src/app/models/bet/betsAndOutcomesForBetTypeGroup.interface';
import { LoaderService } from 'src/app/services/loader.service';
declare let $: any;

@Component({
  selector: 'app-events-live-mobile',
  templateUrl: './events-live-mobile.component.html',
  styleUrls: ['./events-live-mobile.component.less'],
  animations: [blinkBorderAnimation]
})
export class EventsLiveMobileComponent implements OnInit, OnDestroy, AfterViewInit {

  eventsAndSelections: IEventsAndSelectionsMobileLive[];
  arr = Array;
  private events: { [id: number]: EventVM } = {};

  // ovde mora biti i sportid ukljucen
  private selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] } = {};
  pageTypeEnum = PageType;
  private language: string;
  public languageForBetradar: string;
  public isLive: boolean;
  public betOutcomeOddDifferenceEnum = BetOutcomeOddDifference;
  public isMobileView: boolean;
  public orderBySport = true;
  favoriteEvents: EventVM[] = [];
  public betsAndOutcomesForEvents: { [eventId: number]: IBetsAndOutcomesForBetTypeGroup } = {};

  private subscription: Subscription = new Subscription();

  private sportOrdering: number[] = [];

  expandedEvent: EventVM = null;

  expandedSportIds: number[] = [];

  swipeElement: any;
  xDown = null;
  yDown = null;


  @HostListener('touchstart', ['$event'])
  handleStartTouch(event) {
    if (event.target.className.match('swipe-event') && !this.orderBySport) {
      this.touchStart(event);

    }
  }
  // @HostListener('touchmove', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel', ['$event'])
  handleEndTouch(event) {
    if (event.target.className.match('swipe-event') && !this.orderBySport) {
      this.touchEnd(event);

    }
  }

  constructor(
    private eventsService: EventsService,
    private sportsService: SportsService,
    private ticketService: TicketService,
    private cacheChangesService: CacheChangesService,
    private cacheService: CacheService,
    private changesUpdater: ChangesUpdaterService,
    private storageService: StorageService,
    private scrollService: ScrollService,
    private utilityService: UtilityService,
    private loaderService: LoaderService) {

    this.orderBySport = !this.eventsService.orderEventsByTime;
    this.subscription.add(this.eventsService.eventsOrderChanged$.subscribe((obc) => this.changeOrdering(obc)));
    this.language = storageService.language;
    this.languageForBetradar = LocaleHelper.languageForBetradar[this.language];

    this.isMobileView = this.utilityService.mobileView;

    this.eventsService.expandedEvent$.subscribe((ev) => this.expandedEvent = ev);
    this.subscription.add(this.cacheService.sportTreeElementsWithAddedRemovedEventsChanged$.subscribe(x => {
      this.getLiveOffer(true);
    }));

    this.subscription.add(this.cacheService.betsAndOutcomesAddedRemoved$.subscribe(eventIds => {
        this.updateBetsAndOutcomes(eventIds);
    }));

    this.subscription.add(this.eventsService.getEventsAndSelectionsChanged$.subscribe(ret => {
      this.getEventsAndSelections();
    }));

    this.ticketService.ticketItemAddedRemoved$.subscribe((identifier) => {
      this.selectBetOutcomeFromTicket(identifier);
    });
  }

  ngOnInit(): void {
    this.cacheChangesService.unsubscribeForAllChangesPm();
    this.loaderService.showHideLoader(true);
    this.getLiveOffer(false);
  }

  showDetail(event: EventVM) {
    this.eventsService.expandEvent(event);

    if (event.isExpanded) {
      this.expandedEvent = event;
      this.scrollService.expandEventLiveChange(true);
    } else {
      this.scrollService.expandEventLiveChange(false);
      this.expandedEvent = null;
    }
  }

  touchStart(event) {
    if (event.target.scrollLeft + event.target.clientWidth < event.target.scrollWidth) {
      event.target.parentElement.parentElement.parentElement.classList.add('stop');
    } else {
      this.touchEnd(event);
    }
  }

  touchEnd(event) {
    setTimeout(() => {
      event.target.parentElement.parentElement.parentElement.classList.remove('stop');
    }, 300);
  }

  expand(eventsAndSelection: IEventsAndSelectionsMobileLive) {
    eventsAndSelection.isExpanded = !eventsAndSelection.isExpanded;
    if (eventsAndSelection.isExpanded) {
      if (!this.expandedSportIds.includes(eventsAndSelection.sportId)) {
        this.expandedSportIds.push(eventsAndSelection.sportId);
      }
    } else {
      const index = this.expandedSportIds.findIndex(spId => spId === eventsAndSelection.sportId);
      if (index > -1) {
        this.expandedSportIds.splice(index, 1);
      }
    }
  }

  changeOrdering(orderBycompetition: boolean) {
    this.orderBySport = !orderBycompetition;
    this.eventsAndSelections = this.eventsService.getEventsWithSelectionsForOrderingMobileLive(this.orderBySport, this.events, this.selectionsDictionary, this.sportOrdering, this.expandedSportIds);

    if (!this.orderBySport) {
      const interval = setInterval(() => { this.start(interval); }, 100);
    }
  }

  fillEventsWithResults(results: IEventLiveResultInfo[]) {
    for (const result of results) {
      if (this.events[result.eventId]) {
        this.events[result.eventId].result = result;
      }
    }
  }

  getSportName(sportId: number): string {
    return this.utilityService.getSportIcon(sportId);
  }

  getLiveOffer(isUpdate: boolean) {
    this.eventsService.getLiveEventsSelectionsAndSportOrdering().subscribe((eso) => {
      // this.cacheChangesService.subscribeForAllChangesLive();
      this.sportOrdering = eso.sportOrdering;
      const eventIdsForOutcomes = [];
      if (isUpdate) {
        for (const evIdStr of Object.keys(eso.events)) {
          if (!this.events[+evIdStr]) {
            eventIdsForOutcomes.push(+evIdStr);
          }
        }
        // delete Events and bets(for deleted in cache)
        for (const evIdStr of Object.keys(this.events)) {
          if (!eso.events[+evIdStr]) {
            if (this.betsAndOutcomesForEvents[+evIdStr]) {
              delete this.betsAndOutcomesForEvents[+evIdStr];
            }
          }
        }
      }else{
        this.loaderService.showHideLoader(false);
      }
      this.events = eso.events;
      this.selectionsDictionary = eso.selectionsDictionary;
      this.eventsService.favoriteLiveEventIds = this.storageService.favoriteLiveEvents;
      this.eventsAndSelections = this.eventsService.getEventsWithSelectionsForOrderingMobileLive(this.orderBySport, this.events, this.selectionsDictionary, this.sportOrdering, this.expandedSportIds);
      if (eventIdsForOutcomes.length > 0) {
        this.addBetsAndOutcomesForEvents(eventIdsForOutcomes);
      } else {
        this.getBetsAndOutcomes();
      }
    });
  }

  selectBetOutcomeFromTicket(identifier: ITicketItemIdentifier){
    const betOutcome = this.findBetOutcome(identifier.eventId, identifier.betTypeId, identifier.betId, identifier.betTypeOutcomeId, identifier.betOutcomeId);
    if (betOutcome) {
      if (identifier.isAdded) {
        betOutcome.isSelected = true;
      } else {
        betOutcome.isSelected = false;
      }
    }
  }

  toggleEventOutcome(event: EventVM, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
    if (!((event.isPlayable && bet.isPlayable && outcome.isPlayable) || outcome.isSelected)) {
      return;
    }
    this.ticketService.toggleEventOutcome(event, bet, outcome, betTypeOutcomeName, betTypeName);
  }

  private getEventsAndSelectionsAndSetSelected() {
    const evAndSel = this.eventsService.getEventsWithSelectionsForOrderingMobileLive(this.orderBySport, this.events, this.selectionsDictionary, this.sportOrdering, this.expandedSportIds);
    for (const eventsWithSelections of evAndSel) {
      const eventsWithSel = this.eventsAndSelections.find(x => x.sportId === eventsWithSelections.sportId);
      if (eventsWithSel) {
        eventsWithSelections.isExpanded = eventsWithSel.isExpanded;
      }
    }
    this.eventsAndSelections = evAndSel;
  }

  ngAfterViewInit() {
    if (!this.orderBySport) {
      const interval = setInterval(() => { this.start(interval); }, 100);
    }

  }

  toggleClass(event) {
    event.currentTarget.classList.toggle('slide');
  }

  // ovo bi trebao pozivati emmiter iz eventa
  toggleFavorites(event: EventVM) {
    this.eventsService.toggleFavorites(event);
    // const sportID = event.sportId;
    // if (event.isInFavorite) {
    //   event.isInFavorite = false;
    //   this.eventsService.favoriteLiveEventIds.splice(this.eventsService.favoriteLiveEventIds.indexOf(event.id), 1);
    //   this.storageService.favoriteLiveEvents = this.eventsService.favoriteLiveEventIds;
    // } else {
    //   event.isInFavorite = true;
    //   this.eventsService.favoriteLiveEventIds.push(event.id);
    //   this.storageService.favoriteLiveEvents = this.eventsService.favoriteLiveEventIds;
    // }

  }

  getEventsAndSelections(){
    const expandedList = [];
    this.eventsAndSelections.forEach(ev => {
      if (ev.isExpanded === true) {
        expandedList.push(ev.sportId);
      }
    });
    this.eventsAndSelections = this.eventsService.getEventsWithSelectionsForOrderingMobileLive(true, this.events, this.selectionsDictionary, this.sportOrdering);
    expandedList.forEach(expandedEvent => {
      this.eventsAndSelections.find(ev => ev.sportId === expandedEvent).isExpanded = true;
    });
    // document.querySelector('.name-result-wrap .name').addEventListener('touchstart', () => {
    // });
    if (!this.orderBySport) {
      const interval = setInterval(() => { this.start(interval); }, 100);
    }
  }

  private getBetsAndOutcomes() {
    this.betsAndOutcomesForEvents = {};
    for (const eventId of Object.keys(this.events)) {
      if (this.events[+eventId] && this.selectionsDictionary[this.events[+eventId].sportId]) {
        this.betsAndOutcomesForEvents[+eventId] = this.cacheService.getBetsAndOutcomesForBetTypeSelections(+eventId, this.selectionsDictionary[this.events[+eventId].sportId]);
      }
    }
  }

  private addBetsAndOutcomesForEvents(eventIds: number[]) {
    for (const eventId of eventIds) {
      if (this.events[eventId] && this.selectionsDictionary[this.events[eventId].sportId]) {
        this.betsAndOutcomesForEvents[eventId] = this.cacheService.getBetsAndOutcomesForBetTypeSelections(eventId, this.selectionsDictionary[this.events[eventId].sportId]);
      }
    }
  }

  private updateBetsAndOutcomes(eventIdsToUpdate) {
    for (const eventId of eventIdsToUpdate) {
      if (this.events[eventId] && this.selectionsDictionary[this.events[eventId].sportId]) {
        this.betsAndOutcomesForEvents[eventId] = this.cacheService.getBetsAndOutcomesForBetTypeSelections(eventId, this.selectionsDictionary[this.events[eventId].sportId]);
      }
    }
  }

  findBetOutcome(eventId: number, betTypeId: number, betId: number, betTypeOutcomeId: number, betoutcomeId: number): IBetOutcome {
    if (this.betsAndOutcomesForEvents[eventId]) {
      if (this.betsAndOutcomesForEvents[eventId].betOutcomes[betId] && this.betsAndOutcomesForEvents[eventId].betOutcomes[betId][betTypeOutcomeId]) {
        const betOutcome = this.betsAndOutcomesForEvents[eventId].betOutcomes[betId][betTypeOutcomeId].find(bo => bo.id === betoutcomeId);
        if (betOutcome) {
          return betOutcome;
        }
      }
    }

    return null;
  }

  start(interval) {
    if (document.getElementsByClassName('event-wrap')[0] !== undefined) {
      const a = $('.events-main-wrap:not(.stop)');
      if (!a.listSwipe) {
        clearInterval(interval);
        return;
      }
      a.listSwipe({
        itemSelector: '.event-wrap .slider:not(.stop)',
        itemActionWidth: 120,
        leftAction: false
      });

      clearInterval(interval);
    }
  }

  headToHeadWidget(betRadarEventId: number) {
    // tslint:disable:no-string-literal
    // window['SIR']('removeWidget', '#sr-widget');

    this.eventsService.openCloseHeadToHeadWidget(betRadarEventId);
    // if (!this.showH2Hwidget) {
    //   this.eventsService.openCloseHeadToHeadWidget(this.event.betRadarEventId);
    // }
    // else{
    //   this.eventsService.openCloseHeadToHeadWidget();
    //   if (window['SIR']) {
    //     window['SIR']('removeWidget', document.querySelector('.sr-widget'));
    //   }
    // }
  }

  // getTouches(evt) {
  //   return evt.touches ||             // browser API
  //          evt.originalEvent.touches; // jQuery
  // }

  handleTouchStart(evt) {
    const firstTouch = evt.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  }

  handleTouchMove(evt) {
    if (!this.xDown || !this.yDown) {
      return;
    }

    // console.log(event.currentTarget);

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        // console.log('idee lijevoo');
        // this.swipeElement.classList.add('open');
      } else {
        /* right swipe */
        // console.log('idee desnooo');
        evt.classList.remove('open');
        // this.swipeElement.classList.remove('open');
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    /* reset values */
    this.xDown = null;
    this.yDown = null;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.cacheChangesService.removeSportsSubscribtion(true);
    this.cacheChangesService.unsubscribeForAllChangesLive();
    // this.subscription.unsubscribe();
  }
}
